module.exports = __webpack_public_path__ + "static/media/liquity-logo.e9135a84.svg";